import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, Checkbox } from "antd";
import "./StakeHolder.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
import Number from "../../../Components/Number/Number";
const { TextArea } = Input;
class StakeHolderQuote extends Component {
  formRef = React.createRef();
  state = {
    data: [],
    invitationid: this.props.invitationid,
    vendorid: this.props.vendorid,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get(
      "/getQouteList?invitationid=" +
        this.state.invitationid +
        "&vendorid=" +
        this.state.vendorid
    ).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        this.setState({
          data: response.data.retData,
        });
      }
    });
  };
  render() {
    return (
      <div id="stakeholder">
        {this.state.data.map((el, index) => (
          <div style={{borderBottomStyle: "solid", borderBottomWidth: "0.1px", borderBottomColor: "black"}}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="Label">Хүчинтэй хугацаа: {el.qoutedate}</div>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="Label">Бараа нийлүүлэх болон ажил гүйцэтгэх эцсийн хугацаа: {el.deliverydate}</div>
              </Col>
            </Row>
            {el.batchname ? 
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="Label">Багц: {el.batchname}</div>
              </Col>
            </Row> : null}
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="Label">Тендерийн нийт үнэ: <Number symbol value={el.qouteamount} /></div>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(StakeHolderQuote);
